module.exports = __webpack_public_path__ + "img/logo.162fa778.png";